export const AppStoreRedirectRoutes = {
    ROOT: "/georgeapp",
    CAMPAIGN: "/georgeapp-campaign"
};


// WEBPACK FOOTER //
// ./src/components/appStoreRedirect/AppStoreRedirectRoutesNew.ts